import { Link } from 'react-router-dom';
import { Heart, Menu, X } from 'lucide-react';
import { useState } from 'react';
import { usePropertyStore } from '../store/usePropertyStore';
import sigaLogo from '../assets/siga-logo.png';

export default function Header() {
  const favorites = usePropertyStore(state => state.favorites);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src={sigaLogo}
              alt="Siga Imóveis Sob Medida"
              className="h-12"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link to="/sobre" className="text-forest-900 hover:text-jungle-600 transition-colors text-sm font-medium">
              Quem Somos
            </Link>
            <Link to="/anuncie-seu-imovel" className="text-forest-900 hover:text-jungle-600 transition-colors text-sm font-medium">
              Anuncie seu imóvel
            </Link>
            <Link to="/contato" className="text-forest-900 hover:text-jungle-600 transition-colors text-sm font-medium">
              Contato
            </Link>
            <Link to="/simulador-financiamento" className="text-forest-900 hover:text-jungle-600 transition-colors text-sm font-medium">
              Simulador
            </Link>
            <Link to="/seja-um-corretor" className="text-forest-900 hover:text-jungle-600 transition-colors text-sm font-medium">
              Seja um Corretor
            </Link>
            <Link to="https://cliente.portalunsoft.com.br/login/sigasp" className="text-forest-900 hover:text-jungle-600 transition-colors text-sm font-medium">
              Área do cliente
            </Link>
            <Link to="/blog" className="text-forest-900 hover:text-jungle-600 transition-colors text-sm font-medium">
              Blog
            </Link>
            <Link to="/favoritos" className="relative p-2 hover:bg-gray-100 rounded-full transition-colors">
              <Heart className="w-5 h-5 text-forest-900" />
              {favorites.length > 0 && (
                <span className="absolute -top-1 -right-1 bg-jungle-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {favorites.length}
                </span>
              )}
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <div className="flex items-center gap-4 lg:hidden">
            <Link to="/favoritos" className="relative p-2 hover:bg-gray-100 rounded-full transition-colors">
              <Heart className="w-5 h-5 text-forest-900" />
              {favorites.length > 0 && (
                <span className="absolute -top-1 -right-1 bg-jungle-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {favorites.length}
                </span>
              )}
            </Link>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              aria-label="Menu"
            >
              {mobileMenuOpen ? (
                <X className="w-6 h-6 text-forest-900" />
              ) : (
                <Menu className="w-6 h-6 text-forest-900" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {mobileMenuOpen && (
          <nav className="lg:hidden pb-4 animate-fadeIn">
            <div className="flex flex-col space-y-2">
              <Link
                to="/sobre"
                className="text-forest-900 hover:text-jungle-600 hover:bg-gray-50 transition-colors px-4 py-3 rounded-lg text-sm font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Quem Somos
              </Link>
              <Link
                to="/anuncie-seu-imovel"
                className="text-forest-900 hover:text-jungle-600 hover:bg-gray-50 transition-colors px-4 py-3 rounded-lg text-sm font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Anuncie seu imóvel
              </Link>
              <Link
                to="/contato"
                className="text-forest-900 hover:text-jungle-600 hover:bg-gray-50 transition-colors px-4 py-3 rounded-lg text-sm font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contato
              </Link>
              <Link
                to="/simulador-financiamento"
                className="text-forest-900 hover:text-jungle-600 hover:bg-gray-50 transition-colors px-4 py-3 rounded-lg text-sm font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Simulador
              </Link>
              <Link
                to="/seja-um-corretor"
                className="text-forest-900 hover:text-jungle-600 hover:bg-gray-50 transition-colors px-4 py-3 rounded-lg text-sm font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Seja um Corretor
              </Link>
              <Link
                to="https://cliente.portalunsoft.com.br/login/sigasp"
                className="text-forest-900 hover:text-jungle-600 hover:bg-gray-50 transition-colors px-4 py-3 rounded-lg text-sm font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Área do cliente
              </Link>
              <Link
                to="/blog"
                className="text-forest-900 hover:text-jungle-600 hover:bg-gray-50 transition-colors px-4 py-3 rounded-lg text-sm font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Blog
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
